// import Swiper bundle with all modules installed
import Swiper, {Navigation, Pagination, Autoplay, EffectFade} from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

// GSAP Plugins
// gsap.registerPlugin(ScrollTrigger);

export default {
    init() {
        // console.log('PRODUCT');

        // eslint-disable-next-line no-unused-vars
        const productsSwiper = new Swiper('.upsell-carousel', {
            slidesPerView: 'auto',
            spaceBetween: 30,
            // loop: true,
            navigation: {
                nextEl: '.button-prev-kawa',
                prevEl: '.button-next-kawa',
            },
            breakpoints: {
                992: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
            },
            autoplay: {
                delay: 6000,
                disableOnInteraction: true,
            },
        });

        // eslint-disable-next-line no-unused-vars
        const relatedSwiper = new Swiper('.related-carousel', {
            slidesPerView: 'auto',
            spaceBetween: 30,
            breakpoints: {
                992: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
            },
            autoplay: {
                delay: 6000,
                disableOnInteraction: true,
            },
        });

        // SINGLE PRODUCT QUANTITY
        const plus = $('body.single-product #main .quantity .plus');
        const minus = $('body.single-product #main .quantity .minus');

        plus.on('click', function () {
            const input = $(this).parents('.quantity').find('input.qty');
            const max = parseInt($(this).parents('.quantity').find('input.qty').attr('max'));
            const quantity = parseInt($(this).parents('.quantity').find('input.qty').val()) + 1;
            if (isNaN(max)) {
                input.val(quantity);
                minus.prop('disabled', false);
                plus.prop('disabled', false);
            } else {
                if ((quantity <= (max - 1)) && (quantity > 0)) {
                    input.val(quantity);
                    minus.prop('disabled', false);
                    plus.prop('disabled', false);
                } else if (quantity === (max)) {
                    input.val(quantity);
                    minus.prop('disabled', false);
                    plus.prop('disabled', true);
                }
            }
        });
        minus.on('click', function () {
            const input = $(this).parents('.quantity').find('input.qty');
            const max = parseInt($(this).parents('.quantity').find('input.qty').attr('max'));
            const quantity = parseInt($(this).parents('.quantity').find('input.qty').val()) - 1;
            if (isNaN(max)) {
                if (quantity >= 2) {
                    plus.prop('disabled', false);
                    minus.prop('disabled', false);
                    input.val(quantity);
                } else if (quantity === 1) {
                    input.val(quantity);
                    minus.prop('disabled', true);
                }
            } else {
                if ((quantity < max) && (quantity >= 2)) {
                    plus.prop('disabled', false);
                    minus.prop('disabled', false);
                    input.val(quantity);
                } else if (quantity === 1) {
                    input.val(quantity);
                    minus.prop('disabled', true);
                }
            }
        });

        // PRODUCT GALLERY
        const galleryImageBtns = $('.product-gallery-photo');
        const productImages = $('.product-photo');

        $('.product-gallery-photo-01').click(function () {
            if (!$(this).hasClass('active')) {
                productImages.removeClass('active');
                galleryImageBtns.removeClass('active');
                $('#product-photo-01').addClass('active');
                $('.product-gallery-photo-01').addClass('active');
            }
        });
        $('.product-gallery-photo-02').click(function () {
            if (!$(this).hasClass('active')) {
                productImages.removeClass('active');
                galleryImageBtns.removeClass('active');
                $('#product-photo-02').addClass('active');
                $('.product-gallery-photo-02').addClass('active');
            }
        });
        $('.product-gallery-photo-03').click(function () {
            if (!$(this).hasClass('active')) {
                productImages.removeClass('active');
                galleryImageBtns.removeClass('active');
                $('#product-photo-03').addClass('active');
                $('.product-gallery-photo-03').addClass('active');
            }
        });
        $('.product-gallery-photo-04').click(function () {
            if (!$(this).hasClass('active')) {
                productImages.removeClass('active');
                galleryImageBtns.removeClass('active');
                $('#product-photo-04').addClass('active');
                $('.product-gallery-photo-04').addClass('active');
            }
        });

        // SELECT2 INPUTS
        // $('#pa_waga').css('width', "100%");
        // $('#pa_czy-kawa-ma-zostac-zmielona').css('width', "100%");
        // $('#pa_rozmiar').css('width', "100%");
        // $('#kolor').css('width', "100%");
        // $('#jak-wypalona').css('width', "100%");

        // $('#pa_waga').select2({
        //     placeholder: 'Wybierz wagę',
        //     multiple: false,
        //     minimumResultsForSearch: -1,
        //     allowClear: false,
        //     dropdownParent: $('#pa_waga').parent(),
        // });
        // $('#pa_czy-kawa-ma-zostac-zmielona').select2({
        //     placeholder: 'Czy kawa ma zostać zmielona',
        //     multiple: false,
        //     minimumResultsForSearch: -1,
        //     allowClear: false,
        //     dropdownParent: $('#pa_czy-kawa-ma-zostac-zmielona').parent(),
        // });
        // $('#pa_rozmiar').select2({
        //     placeholder: 'Wybierz rozmiar',
        //     multiple: false,
        //     minimumResultsForSearch: -1,
        //     allowClear: false,
        //     dropdownParent: $('#pa_rozmiar').parent(),
        // });
        // $('#kolor').select2({
        //     placeholder: 'Wybierz kolor',
        //     multiple: false,
        //     minimumResultsForSearch: -1,
        //     allowClear: false,
        //     dropdownParent: $('#kolor').parent(),
        // });
        // $('#jak-wypalona').select2({
        //     placeholder: 'Wybierz typ wypalenia',
        //     multiple: false,
        //     minimumResultsForSearch: -1,
        //     allowClear: false,
        //     dropdownParent: $('#jak-wypalona').parent(),
        // });

        // RE INIT SELECT2 on each change
        // $('#pa_waga').on('select2:select', function () {
        //     console.log('onChange - re init select 2 - WAGA');
        //     $('#pa_waga').select2('destroy').select2({
        //         placeholder: 'Wybierz wagę',
        //         multiple: false,
        //         minimumResultsForSearch: -1,
        //         allowClear: false,
        //         dropdownParent: $('#pa_waga').parent(),
        //     });
        // });
        // $('#pa_czy-kawa-ma-zostac-zmielona').on('select2:select', function () {
        //     console.log('onChange - re init select 2 - MIELONA');
        //     $('#pa_czy-kawa-ma-zostac-zmielona').select2('destroy').select2({
        //         placeholder: 'Czy kawa ma zostać zmielona',
        //         multiple: false,
        //         minimumResultsForSearch: -1,
        //         allowClear: false,
        //         dropdownParent: $('#pa_czy-kawa-ma-zostac-zmielona').parent(),
        //     });
        // });
        // $('#pa_rozmiar').on('select2:select', function () {
        //     $('#pa_rozmiar').select2('destroy').select2({
        //         placeholder: 'Wybierz rozmiar',
        //         multiple: false,
        //         minimumResultsForSearch: -1,
        //         allowClear: false,
        //         dropdownParent: $('#pa_rozmiar').parent(),
        //     });
        // });
        // $('#kolor').on('select2:select', function () {
        //     $('#kolor').select2('destroy').select2({
        //         placeholder: 'Wybierz kolorę',
        //         multiple: false,
        //         minimumResultsForSearch: -1,
        //         allowClear: false,
        //         dropdownParent: $('#kolor').parent(),
        //     });
        // });
        // $('#jak_wypalona').on('select2:select', function () {
        //     $('#jak_wypalona').select2('destroy').select2({
        //         placeholder: 'Wybierz typ wypalenia',
        //         multiple: false,
        //         minimumResultsForSearch: -1,
        //         allowClear: false,
        //         dropdownParent: $('#jak_wypalona').parent(),
        //     });
        // });

        // INIT inputs / disable minus button if quantity equals 1
        const inputContainer = $('#single-product div.quantity');
        if ((inputContainer.find('input.qty').val()) == 1) {
            inputContainer.find('.minus').prop('disabled', true);
        } else {
            inputContainer.find('.minus').prop('disabled', false);
        }

        // ROLE PRICING PLUGIN GLITCH FIX
        // const priceItems = $('p.price');
        // priceItems.each(function () {
        //     const regular = $(this).find('span.ywcrbp_regular_price');
        //     const your = $(this).find('span.ywcrbp_your_price');
        //     const regularText = regular.find('span.woocommerce-Price-amount bdi').text();
        //     const yourText = your.find('span.woocommerce-Price-amount bdi').text();
        //     if (regularText == yourText) {
        //         your.hide();
        //     }
        // });

        // MOVE PACKAGE CHECKBOXES
        // const variationsForm = $('#single-product form.variations_form');
        // const checkboxContainer = $('#single-product #yith-wapo-container');
        // // console.log('variationsForm', variationsForm);
        // // console.log('checkboxContainer', checkboxContainer);
        // variationsForm.prepend(checkboxContainer);

        // // IF IS SINGLE VARIATION PRICE IS MISSING
        // const missingPriceContainer = $('#single_variation_wrap .woocommerce-variation.single_variation');
        // // console.log(missingPriceContainer);
        // // console.log(missingPriceContainer.length);
        // const missingPrice = $('div.add-to-cart-section > p.price > span > bdi');
        // const missingPriceText = missingPrice.text();
        // const missingPriceSlice = missingPriceText.slice(0, -3);
        // const priceElement = '<div class="woocommerce-variation single_variation flex-grow-1"><div class="woocommerce-variation-price"><span class="price"><span class="woocommerce-Price-amount amount"><bdi>' + missingPriceSlice + '&nbsp;<span class="woocommerce-Price-currencySymbol">zł</span></bdi></span></span></div></div>';
        // // console.log(missingPrice);
        // // console.log(missingPriceText);
        // // console.log(missingPriceSlice);
        
        // if (missingPriceContainer.length===1 & missingPrice.length===1) {
        //     // console.log('BRAK CENY FIX');
        //     $('#single_variation_wrap').prepend( priceElement );
        // }

    },
}



// WEBPACK FOOTER //
// ./scripts/routes/product.js